import { ca } from '@cian/analytics';

export function trackStartVideo() {
  ca('eventSite', {
    action: 'start',
    label: 'Video',
    category: 'Mortgage',
    name: 'oldevent',
  });
}

export function trackQuarterWasShown() {
  ca('eventSite', {
    action: 'complete_25',
    label: 'Video',
    category: 'Mortgage',
    name: 'oldevent',
  });
}

export function trackHalfWasShown() {
  ca('eventSite', {
    action: 'complete_50',
    label: 'Video',
    category: 'Mortgage',
    name: 'oldevent',
  });
}

export function trackThreeQuartersWasShown() {
  ca('eventSite', {
    action: 'complete_75',
    label: 'Video',
    category: 'Mortgage',
    name: 'oldevent',
  });
}

export function trackFinishVideo() {
  ca('eventSite', {
    action: 'finish',
    label: 'Video',
    category: 'Mortgage',
    name: 'oldevent',
  });
}
